<template>
  <div ref="holder" class="flex-grow-1 d-flex flex-column">
    <div class="flex-grow-1"></div>
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" sm="10" md="8" lg="6" xl="4">
          <b-card>
            <b-row align-h="center">
              <b-col cols="6" md="4">
                <p class="text-center h4">
                  <b-link to="/">
                    <img
                      src="@/assets/synaplus_logo_square_outlinev2.svg"
                      alt="Synaplus"
                    />
                  </b-link>
                </p>
              </b-col>
            </b-row>

            <p class="text-center h5">
              <b> {{ $t('welcome_login') }} </b>
            </p>
            <p class="text-center h6">
              <b> {{ $t('access_cosmo') }} </b>
            </p>
            <h6>{{ ' ' }}</h6>
            <b-form>
              <b-alert
                v-if="invalid_login_or_password"
                show
                variant="warning"
                >{{ $t('invalid_input') }}</b-alert
              >
              <b-form-group class="my-4">
                <label class="mb-0">
                  <b>{{ $t('username') }}</b>
                </label>
                <b-input-group>
                  <b-input-group-prepend is-text
                    ><span class="fas fa-user-tie fa-fw"
                  /></b-input-group-prepend>
                  <b-form-input
                    v-model="username"
                    :placeholder="$t('username')"
                    type="text"
                    name="username"
                    tabindex="1"
                    autofocus
                    @keydown.enter="login"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group class="my-4">
                <label class="mb-0">
                  <b>{{ $t('password') }}</b>
                </label>
                <b-input-group>
                  <b-input-group-prepend is-text
                    ><span class="fas fa-key fa-fw"
                  /></b-input-group-prepend>
                  <b-form-input
                    v-model="password"
                    :placeholder="$t('password')"
                    type="password"
                    name="password"
                    tabindex="2"
                    autocomplete="on"
                    @keydown.enter="login"
                  />
                </b-input-group>
              </b-form-group>
              <b-button
                :block="true"
                class="my-4"
                variant="primary"
                tabindex="3"
                @click="login"
                >{{ $t('login') }}</b-button
              >
            </b-form>
            <b-form v-if="allow_hardreboot">
              <b-button
                :block="true"
                class="my-4"
                variant="primary"
                tabindex="3"
                @click="hardreboot"
                >{{ $t('hardreboot') }}</b-button
              >
            </b-form>
          </b-card>
          <div class="d-flex justify-content-between flex-wrap">
            <b-dropdown variant="link" size="sm">
              <template slot="button-content">{{
                $t('current_language')
              }}</template>
              <b-dropdown-item @click="set_locale('en')"
                >English (United States)</b-dropdown-item
              >
              <b-dropdown-item @click="set_locale('fr')"
                >Français (France)</b-dropdown-item
              >
            </b-dropdown>
            <b-button variant="link" size="sm" to="/help">{{
              $t('help')
            }}</b-button>
          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <p style="font-size:10px">Client id : {{ client_license_id }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="flex-grow-1"></div>
  </div>
</template>

<i18n>
{
  "en": {
    "welcome_login": "Welcome, please sign in",
    "access_cosmo": "to continue to Cosmo",
    "invalid_input": "Invalid Username and / or Password",
    "username": "Username",
    "password": "Password",
    "login": "Sign in",
    "help": "Help",
    "current_language": "English (United States)",
    "license_data_being_gathered": "License data is being collected",
    "hardreboot": "Hard reboot"
  },
  "fr": {
    "welcome_login": "Bienvenue, identifiez-vous",
    "access_cosmo": "pour accéder à Cosmo",
    "invalid_input": "Nom d'utilisateur et / ou mot de passe invalide(s)",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "login": "Identifiez-vous",
    "help": "Aide",
    "current_language": "Français (France)",
    "license_data_being_gathered": "Les données de licence sont en cours de collecte",
    "hardreboot": "Redémarrage forcé"
  }
}
</i18n>

<script>
import $ from 'jquery'
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

import { get_client_id, hardreboot } from '@/api/subscriptions.js'

import { subscription_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'Login',
  components: {},
  mixins: [subscription_mixin],
  data() {
    return {
      username: '',
      password: '',
      client_id: undefined,
    }
  },
  computed: {
    client_license_id() {
      let res
      if (_.isUndefined(this.client_id)) {
        res = this.$t('license_data_being_gathered')
      } else {
        res = this.client_id
      }
      return res
    },
    ...mapState(['invalid_login_or_password', 'allow_hardreboot']),
    ...mapGetters(['user_is_authenticated']),
  },
  watch: {
    user_is_authenticated(nv) {
      if (nv) {
        let path = this.$route.query.redirect || '/'
        this.$router.replace(path)
      }
    },
  },
  async mounted() {
    await this.get_client_id()
  },
  beforeMount() {
    this.$store.dispatch('init')
    this.$store.dispatch('init_login_info')
    this.fetch_collections(['users', 'project_rights'])
  },

  methods: {
    login() {
      let { username, password } = this
      this.$store.dispatch('ask_for_login', {
        username,
        password,
      })
    },
    async get_client_id() {
      let res_client_id = (await get_client_id()) || {}
      this.client_id = res_client_id.client_id
      this.$store.commit(
        'set_client_encryption_key',
        res_client_id.client_encryption_key
      )
    },
    set_locale(language) {
      this.$store.commit('update_locale', language)
    },
    hardreboot() {
      hardreboot()
    },
  },
}
</script>
